<template>
    <div class="info-box-rd-nummer-falsch w-100">
        <div class="mx-4 py-3 d-flex flex-row align-items-center">
            <span class="ms-2 me-3">
                <kleiner_fehler_icon></kleiner_fehler_icon>
            </span>
            <div>
                <b>{{ message }}</b>
            </div>
        </div>
    </div>
</template>

<script setup>
import kleiner_fehler_icon from '@/components/icons/kleiner_fehler_icon.vue';

const props = defineProps({
    message: {
        type: String,
        required: true
    }
});


</script>